import { Middleware } from 'redux';

import bannersModule, { BannerTypes } from 'modules/banners';

const bannerDevMiddleware: Middleware = ({ dispatch }) => next => (
    action: any
) => {
    const { type, payload } = action;
    const {
        actions: { setCmsBanners },
        constants: { GET_BANNERS_DATA_SUCCESS },
    } = bannersModule;

    const bannerStubs: [BannerTypes.BannerInfo, ...BannerTypes.BannerInfo[]] = [
        {
            id: 'banner:betting',
            imageHref: '/en/news/just-bet-and-win-prizes',
            imageSrc: '/assets/news/promo.png',
            title: 'title 1',
            buttonText: 'my bets',
            buttonHref: '#!/player/profile-bets-history',
        },
        {
            id: 'banner:banner-b2',
            imageHref: '/en/news/just-bet-and-win-prizes',
            imageSrc: '/assets/news/promo1.png',
            title: 'title 1',
            buttonText: '',
            buttonHref: '',
        },
        {
            id: 'banner:banner-b3',
            imageHref: '/en/news/just-bet-and-win-prizes',
            imageSrc: '/assets/news/promo1.png',
            title: 'title 1',
            buttonText: 'my bets 3',
            buttonHref: '#!/player/profile-bets-history',
        },
    ];

    if (type === GET_BANNERS_DATA_SUCCESS) {
        const banners = (payload.data.banners as BannerTypes.ApiBannerItem[])
            .filter(b => b.type === 'cms_banner')
            .map(({ id }, i) => ({
                ...(bannerStubs[i] ?? bannerStubs[0]),
                id,
            }));

        if (banners.length > 0) {
            setTimeout(() => {
                dispatch(setCmsBanners({ banners }));
            }, 3000);
        }
    }

    return next(action);
};

export default bannerDevMiddleware;
